<template>
	<v-tabs 
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Campi" ripple class="secondary-tab">
			Campi
		</v-tab>
		<v-tab key="Azioni" ripple class="secondary-tab">
			Azioni
		</v-tab>
		<v-tab key="Altro" ripple class="secondary-tab">
			Altro
		</v-tab>

		<v-tab-item class="background-1 pt-3 pb-offset" key="Campi">
			<v-row class="ma-0">
				
				<v-col class="pa-0 pt-2" cols="12">
					<fields-selector model-def="timecard"></fields-selector>
				</v-col>

			</v-row>
		</v-tab-item>
		
		<v-tab-item class="background-1 pt-3 pb-offset" key="Azioni">
			<v-row class="ma-0">
				
				<v-col class="pa-0 pt-2" cols="12">
					<actions-selector model-def="timecard"></actions-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="background-1 pt-3 pb-offset" key="Altro">
			<v-row class="ma-0">
				<timecards-options></timecards-options>
			</v-row>
		</v-tab-item>
	</v-tabs>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import TimecardsOptions from '@/components/modules/timecards/settings/TimecardsOptions.vue'

	export default {
		name:'orders-settings',
        components: {
			FieldsSelector,
			ActionsSelector,
            TimecardsOptions
        },		
		data() {
			return {

			}
		},
	}
  </script>
